import axios from "axios";
import router from "@/router";

const http = axios.create({
  baseURL: process.env.API_ROOT
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem("token");
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = token; //请求头加上token
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      alert(error.response.data.message);
      sessionStorage.clear();
      router.replace({ name: "login" });
      return Promise.reject(response.data.msg);
    }
    return Promise.reject(error);
  }
);

export default http;



//////////////////
// WEBPACK FOOTER
// ./utils/http.js
// module id = null
// module chunks = 